import { externalRequest, requestFunnel } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

const getOptions = () => ({ headers: authenticationService.authHeader() });

export const getAmortizationSchedule = body => {
  const { capitalizationOption } = body;
  const country = capitalizationOption ? 'pe' : 'cl';
  const url = `${process.env.VUE_APP_AMORTIZATION_SCHEDULE_SERVICE_URL}/${country}`;
  return externalRequest.post(url, body).then(result => result.data);
};

export const getTheoreticalAmortisationSchedule = async (operationId, date) => {
  const query = `date=${date}`;
  const result = await requestFunnel.get(
    `amortization-schedule/${operationId}?${query}`,
    getOptions()
  );
  return result.data;
};
